import { render, staticRenderFns } from "./UploadPictureAndVideo.vue?vue&type=template&id=4e3c5886&scoped=true&"
import script from "./UploadPictureAndVideo.vue?vue&type=script&lang=js&"
export * from "./UploadPictureAndVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c5886",
  null
  
)

export default component.exports